import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('institutions', { params: params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        // show: (cntx, { id }) => {
        //     axios.get(`institutions/${id}`)
        //         .then(response => resolve(response))
        //         .catch(error => reject(error))
        // },
        show: (cntx, { id }) => {
            return new Promise((resolve, reject) => {
                axios.get(`institutions/${id}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        create: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.post('institutions', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        update: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.put(`institutions/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        remove: (cntx, id) => {
            return new Promise((resolve, reject) => {
                axios.delete(`institutions/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        levies: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('levies', { params: params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        currencies: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('currencies', { params: params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        banks: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('banks', { params: params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        packages: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('packages', { params: params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        deductibles: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('deductibles', { params: params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        listLoans: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('loans', { params: params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        createLoan: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.post('loans', params)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateLoan: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.put(`loans/${params.id}`, params.data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    }
}